export default class LightHeader extends React.Component {
  render() {
    return(
      <div className="setup-logo-container">
        <img className="setup-brand-symbol" src="/assets/images/brand-symbol.png" />
        <img className="setup-logo" alt="Plug in SEO" src="/assets/images/logo-color.png" />
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./app/components/header/LightHeader.js